




















































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import DescriptionList from '@/components/descriptionlist/DescriptionList.vue';
import Description from '@/components/descriptionlist/Description.vue';

import moment from 'moment';
import axios from 'axios';

@Component({
    components: {
        DescriptionList,
        Description,
    },
})
export default class BasicDetail extends Vue {

    private loading: boolean = false;

    private basicProgress: any[] = [];

    private goodsData: any[] = [];

    private goodsColumns = [{
        title: '商品编号',
        dataIndex: 'id',
        key: 'id',
        customRender: this.goodsIdRender,
    }, {
        title: '商品名称',
        dataIndex: 'name',
        key: 'name',
        customRender: this.renderContent,
    }, {
        title: '商品条码',
        dataIndex: 'barcode',
        key: 'barcode',
        customRender: this.renderContent,
    }, {
        title: '单价',
        dataIndex: 'price',
        key: 'price',
        customRender: this.renderContent,
    }, {
        title: '数量（件）',
        dataIndex: 'num',
        key: 'num',
        align: 'right',
        customRender: this.goodsNumRender,
    }, {
        title: '金额',
        dataIndex: 'amount',
        key: 'amount',
        align: 'right',
        customRender: this.goodsAmountRender,
    } ];

    private progressColumns = [
    {
        title: '时间',
        dataIndex: 'time',
        key: 'time',
    },
    {
        title: '当前进度',
        dataIndex: 'rate',
        key: 'rate',
    },
    {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        customRender: this.progressStateRender,
    },
    {
        title: '操作员ID',
        dataIndex: 'operator',
        key: 'operator',
    },
    {
        title: '耗时',
        dataIndex: 'cost',
        key: 'cost',
    },
    ];

    private mounted(): void {
        axios.get('/api/profile/basic').then((res: any) => {
            const data = res.data;
            this.basicProgress = data.basicProgress;
            this.goodsData = data.basicGoods;
            // console.log(this.goodsData);

            if (data.basicGoods.length) {
                let num = 0;
                let amount = 0;
                data.basicGoods.forEach((item: any) => {
                    num += Number(item.num);
                    amount += Number(item.amount);
                });
                this.goodsData = data.basicGoods.concat({
                    id: '总计',
                    num,
                    amount,
                });
            }
        });
    }

    private renderContent(value: any, row: any, index: number) {
        const obj = {
            children: value,
            attrs: {
                colSpan: 1,
            },
        };
        if (row.id === '总计') {
            obj.attrs.colSpan = 0;
        }
        return obj;
    }

    private goodsIdRender(text: any, record: any, index: any) {
        if (record.id !== '总计') {
            return <a href = '#' > {text} </a>;
        }
        return {
            children: <span style = 'font-weight:600' > 总计 </span>,
            attrs: {
                colSpan: 4,
            },
        };
    }

    private goodsNumRender(text: any, record: any, index: any) {
        if (record.id !== '总计') {
            return text;
        }
        return <span style = 'font-weight:600' > {text} </span>;
    }

    private goodsAmountRender(text: string, record: any, index: any) {
        if (record.id !== '总计') {
            return text;
        }
        return <span style = 'font-weight:600' > {text} </span>;
    }

    private progressStateRender(text: string, record: any, index: any) {
        if (text === 'success') {
            return <a-badge status = 'success' text = '成功' />;
        }
        return <a-badge status = 'processing' text = '进行中' />;
    }
}
